import { FC } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { IconMap } from '../../../shared/sprite';
import { Button, Link, Tooltip } from '../../../shared/ui';
import { callRecordingSettingsModel } from '../../call-recording-settings';

import { useLocalStorage } from '@distribute/frontend/utils';

import { CALL_RECORDING_WALKTHROUGH_POPUP_STORAGE_KEY } from '../../../shared/constants';

export const ConnectCalendarState: FC = () => {
  const [_, setIsWalkthroughPopupOpen] = useLocalStorage(
    CALL_RECORDING_WALKTHROUGH_POPUP_STORAGE_KEY,
    true
  );

  const dispatch = useDispatch();

  const isCalendarConnecting = useSelector(
    callRecordingSettingsModel.selectors.selectIsCalendarConnecting
  );

  const handleCalendarConnect = () => {
    dispatch(callRecordingSettingsModel.actions.connectToGoogleCalendar());
  };

  return (
    <>
      <section className="flex-grow-1 flex flex-col justify-center items-center gap-y-6 px-2">
        <div className="z-0 w-full relative flex items-center justify-center">
          <img
            src="./../../assets/images/bg-pattern-decorative.png"
            alt="decorative"
            className="flex-shrink-0 absolute left-0 right-0 z-0 w-full h-72 object-none"
          />
          <div
            className="absolute left-0 right-0 z-0 w-full h-72"
            style={{
              backdropFilter: 'blur(4px)',
              maskImage: 'radial-gradient(circle, transparent 0%, black 100%)',
            }}
          />
          <div className="z-0 w-50 flex flex-col gap-1.5 p-3 bg-base-white rounded-2xl border border-gray-200">
            <h3 className="text-gray-900 font-semibold text-sm">
              Upcoming meetings
            </h3>
            <div className="flex flex-col gap-1">
              <img
                src="./../../assets/images/upcoming-meetings-zoom.svg"
                alt="Upcoming meetings"
                className="flex-shrink-0"
              />
              <img
                src="./../../assets/images/upcoming-meetings-google.svg"
                alt="Upcoming meetings"
                className="flex-shrink-0"
              />
            </div>
          </div>
        </div>
        <div className="z-0 flex flex-col justify-center items-center gap-y-6 text-center">
          <div>
            <h3 className="text-gray-900 text-md font-semibold">
              Connect your work calendar <br /> to unlock all Distribute Call
              Recorder feature access.
            </h3>
            <p className="text-gray-600 text-sm font-normal">
              Choose a calendar you use for in team.
            </p>
          </div>
          <div className="flex flex-col gap-4 text-center text-gray-600">
            <Button
              loading={isCalendarConnecting}
              variant="icon-text"
              color="secondary"
              className="flex items-center gap-1 font-semibold"
              iconLeftName={IconMap.Google}
              iconLeftWidth={24}
              onClick={handleCalendarConnect}
            >
              Continue with Google
            </Button>
          </div>
        </div>
      </section>
      <div className="text-center mt-auto">
        <Tooltip
          className="max-w-80 font-medium px-3 py-2"
          hideArrow
          trigger={
            <Link size="large" onClick={() => setIsWalkthroughPopupOpen(true)}>
              Why Distribute need access <br /> to your calendar?
            </Link>
          }
        >
          <p>
            Distribute accesses your calendar events with links and displays
            them for you. You can then choose which events you&apos;d like
            Distribute to join and record, giving you complete control over the
            sessions you want recorded.
          </p>
        </Tooltip>
      </div>
    </>
  );
};
